import React from 'react';
import '../styles/About.css';
import { PageHeader } from '../components';

const About: React.FC = () => {
  return (
    <div className="about">
      <PageHeader title="About WiZiAi" />
      <div className="about-container">
        
        
        <div className="about-content">
          <section className="about-section">
            <h2>Revolutionizing Education with Artificial Intelligence</h2>
            <p>
              WiZiAi is India's leading AI-powered educational platform, dedicated to transforming how students prepare for competitive exams like JEE and NEET. Founded by IIT and AIIMS alumni with a vision to democratize quality education, we've helped over 15,000 students achieve their engineering and medical dreams through personalized, intelligent learning solutions.
            </p>
            <p>
              Our cutting-edge platform combines advanced artificial intelligence with proven pedagogical methods to create a truly personalized learning experience. We understand that every student is unique, with different learning patterns, strengths, and areas for improvement. That's why we've developed WiZiAi - your intelligent study companion that adapts to your individual needs and accelerates your path to success.
            </p>
            <p>
              With a 98% success rate and students achieving top ranks in JEE Advanced, JEE Main, and NEET, WiZiAi has established itself as the most trusted name in AI-powered exam preparation. Our mission is to make world-class education accessible to every aspiring engineer and doctor across India.
            </p>
          </section>
          
          <section className="about-section">
            <h2>Our AI-Powered Learning Ecosystem</h2>
            <div className="services-grid">
              <div className="service-item">
                <h3>🎯 WiziBoard Dashboard</h3>
                <p>Comprehensive performance analytics and personalized insights that track your progress across subjects, identify weak areas, and provide actionable recommendations for improvement.</p>
              </div>
              <div className="service-item">
                <h3>🗣️ WiziTalk AI Tutor</h3>
                <p>Voice-enabled AI tutor available 24/7 to solve your doubts instantly. Ask questions naturally and receive detailed explanations with step-by-step solutions in real-time.</p>
              </div>
              <div className="service-item">
                <h3>🏆 WiziRank Leaderboard</h3>
                <p>Gamified learning experience with competitive rankings, peer comparisons, and achievement badges that keep you motivated throughout your preparation journey.</p>
              </div>
              <div className="service-item">
                <h3>📊 Adaptive Mock Tests</h3>
                <p>AI-curated practice tests that adapt to your learning pace, focus on your weak areas, and simulate real exam conditions for optimal preparation.</p>
              </div>
            </div>
          </section>
          
          <section className="about-section">
            <h2>Why Choose WiZiAi</h2>
            <ul className="benefits-list">
              <li>🤖 Advanced AI algorithms for personalized learning paths</li>
              <li>📈 98% success rate with top JEE and NEET ranks achieved</li>
              <li>👨‍🏫 Founded by IIT and AIIMS alumni with 15+ years experience</li>
              <li>🎓 15,000+ students successfully placed in top engineering and medical colleges</li>
              <li>⚡ Instant doubt resolution with voice-enabled AI tutor</li>
              <li>📱 Mobile-friendly platform accessible anytime, anywhere</li>
              <li>🔄 Continuous performance tracking and adaptive learning</li>
              <li>🏅 Gamified learning with leaderboards and achievements</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
